// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getApp, getApps, initializeApp } from "firebase/app";
import { firebaseApiKey, firebaseAppId, firebaseAuthDomain, firebaseMeasurementId, firebaseMessagingSenderId, firebaseProjectId, firebaseStorageBucket } from "./utils/constants";
import { getFirestore } from "@firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: firebaseApiKey,
    authDomain: firebaseAuthDomain,
    projectId: firebaseProjectId,
    storageBucket: firebaseStorageBucket,
    messagingSenderId: firebaseMessagingSenderId,
    appId: firebaseAppId,
    measurementId: firebaseMeasurementId
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

const db = getFirestore(app);

export { db, app }